import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import CarteraDetalleWidget from './widgets/cartera-detalle-widget';
import {FuerzasVenta} from '../../../utils/constants';

class PortadaView extends React.Component {

    public render() {
        return (
            <Container className='dashboard'>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Portada</h3>
                    </Col>
                </Row>
                <Row>
                    <CarteraDetalleWidget fuerzaVenta={FuerzasVenta.GLORIA}/>
                    <CarteraDetalleWidget fuerzaVenta={FuerzasVenta.SAN_FERNANDO}/>
                </Row>
            </Container>
        );
    }
}

export default PortadaView;



// WEBPACK FOOTER //
// ./src/components/pages/portada/portada.tsx